module.exports = __webpack_public_path__ + "static/media/work.46a77674.jpg";